import { ResponsiveLine } from "@nivo/line";
import moment from "moment";
import { VerifiedIncomeGraphData } from "../types";
import { useEffect, useState } from "react";

const theme = {
  text: {
    color: "#8B8D97",
    fontSize: "13px",
    fontFamily: "Satoshi"
  },
  axis: {
    ticks: {
      line: {
        strokeWidth: 0
      },
      text: {
        fill: "#8B8D97",
        fontSize: "13px",
        fontFamily: "Satoshi"
      }
    },
    domain: {
      line: {
        stroke: "rgba(28,29,34,0.100)"
      }
    }
  },
  tooltip: {
    chip: {
      borderRadius: "50%",
      marginRight: "0px",
      height: "8px",
      width: "8px"
    },
    tableCell: {
      fontSize: "13px",
      color: "#1C1D22"
    },
    container: {
      borderRadius: "4px"
    }
  },
  crosshair: {
    line: {
      stroke: "rgba(28,29,34,0.300)",
      strokeWidth: 1,
      strokeDasharray: "2 2"
    }
  },
  grid: {
    line: {
      stroke: "rgba(28,29,34,0.100)",
      strokeWidth: 1,
      strokeDasharray: "2 2"
    }
  }
};

export const VerifiedIncomeChart = ({
  data
}: {
  data: VerifiedIncomeGraphData[];
}) => {
  const [graphData, setGraphData] = useState<VerifiedIncomeGraphData[]>([]);

  useEffect(() => {
    if (data.length > 0) {
      const normalized = normalizeData(data);
      setGraphData(normalized);
    }
  }, [data]);

  const normalizeData = (data: VerifiedIncomeGraphData[]) => {
    const normalizedKeys = Object.keys(
      data.reduce<Record<string, 1>>((acc, d) => {
        d.data.forEach((item) => {
          acc[item.x] = 1;
        });
        return acc;
      }, {})
    );
    return data.map((d) => ({
      ...d,
      data: normalizedKeys
        .reduce<{ x: string; y: number }[]>((acc, x) => {
          acc.push(d.data.find((item) => item.x === x) || { x, y: 0 });
          return acc;
        }, [])
        .sort((a, b) =>
          moment("1 " + a.x).isBefore(moment("1 " + b.x)) ? -1 : 1
        )
    }));
  };
  return (
    <ResponsiveLine
      data={graphData}
      curve="linear"
      animate
      enableSlices="x"
      margin={{ top: 30, right: 20, bottom: 50, left: 70 }}
      yScale={{
        stacked: true,
        type: "linear"
      }}
      yFormat={(value) => {
        const formattedValue = value.toLocaleString("en-US", {
          style: "currency",
          currency: "USD"
        });
        return formattedValue;
      }}
      theme={theme}
      enableGridX={false}
      gridYValues={5}
      axisLeft={{
        tickValues: 3,
        format: (value) => {
          const formattedValue = value.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 0
          });
          return formattedValue;
        }
      }}
      isInteractive={true}
      lineWidth={1}
      pointSize={7}
      enableArea
      colors={(d) => d.color}
      areaOpacity={0.05}
    />
  );
};
